<template>
    <div>
        <app-wysiwyg
            label="Überschrift"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.title'"
            textpicker-namespace="contact/title"
            required
            :maxlength="255"
            :slim="true"
        ></app-wysiwyg>

        <app-wysiwyg
            label="Unterüberschrift"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.subtitle'"
            textpicker-namespace="contact/subtitle"
            required
            :maxlength="255"
            :slim="true"
        ></app-wysiwyg>

        <app-wysiwyg
            label="Text"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.text'"
            textpicker-namespace="contact/text"
            :maxlength="1024"
        ></app-wysiwyg>

        <app-reference
            label="Kontakt"
            @click="openSettings('company')"
            description="Adressdaten"
        ></app-reference>

        <app-link
            v-if="hasPackageBasic"
            label="Button 1"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.link'"
        ></app-link>

        <app-link
            v-if="hasPackageBasic"
            label="Button 2"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.link2'"
        ></app-link>

        <app-link
            v-if="hasPackageBasic"
            label="Button 3"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.link3'"
        ></app-link>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Text from '@/components/fields/simple/Text.vue';
import Wysiwyg from '@/components/fields/simple/Wysiwyg.vue';
import Link from '@/components/assorted/Link.vue';
import Reference from '@/components/assorted/Reference.vue';

export default {
    data() {
        return {};
    },
    methods: {
        ...mapActions(['openSettings'])
    },
    computed: {
        ...mapGetters(['getProp', 'hasPackageBasic'])
    },
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R005'),
            help: this.$helpers.uiText('R051'),
            removeText: this.$helpers.uiText('R052'),
            showGlobal: false
        });
    },
    props: {
        moduleId: String
    },
    components: {
        'app-text': Text,
        'app-wysiwyg': Wysiwyg,
        'app-link': Link,
        'app-reference': Reference
    }
};
</script>
